module.exports = __webpack_public_path__ + "img/pijltje-links-wit.b9eb9f67bb325a86ce3da0a120414ac2.svg";